export const FULFILLMENT_DETAILS_HEADER = 'Fulfillment Information';
